import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePOSSummary } from "@faire/retailer-visitor-shared/features/PointOfSale/hooks/usePOSSummary";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { SignUpType, usePopSignUp } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { LockedConnectionTooltip } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/LockedConnectionTooltip";
import { Button } from "@faire/web--source/slate/Button";
import { FoundationLock } from "@faire/web--source/slate/icons/foundation/Lock";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import pos from "@faire/web-api--source/routes/point-of-sale";
import posOnboarding from "@faire/web-api--source/routes/point-of-sale/onboarding";
import React from "react";
import styled from "styled-components";
export var ConnectButton = function(param) {
    var onClick = param.onClick, element = param.element, small = param.small, tooltipPosition = param.tooltipPosition;
    var isRetailerSubUser = useUserStore([
        "isRetailerSubUser"
    ]).isRetailerSubUser;
    var isLinked = usePOSSummary().isLinked;
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var popSignUp = usePopSignUp().popSignUp;
    var handleSignUp = function() {
        return popSignUp(SignUpType.GENERIC, onClick, {
            element: element,
            sourceId: pos()
        });
    };
    if (!isLoggedInRetailer) {
        return /*#__PURE__*/ _jsx(CTAButtonWrapper, {
            children: /*#__PURE__*/ _jsx(CTAButton, {
                onClick: handleSignUp,
                small: small,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "MSVF8A",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Sign up to get started"
                        }
                    ]
                })
            })
        });
    }
    if (isLinked) {
        return /*#__PURE__*/ _jsx(CTAButtonWrapper, {
            children: /*#__PURE__*/ _jsx(CTAButton, {
                linkTo: pos(),
                onClick: onClick,
                small: small,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "vtvb9W",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "View POS integration"
                        }
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ _jsx(CTAButtonWrapper, {
        children: /*#__PURE__*/ _jsx(LockedConnectionTooltip, {
            hidden: !isRetailerSubUser,
            position: tooltipPosition,
            targetNode: /*#__PURE__*/ _jsx(CTAButton, {
                linkTo: posOnboarding(),
                disabled: isRetailerSubUser,
                onClick: onClick,
                small: small,
                children: /*#__PURE__*/ _jsxs(Row, {
                    gap: "1x",
                    align: "center",
                    children: [
                        /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "QPC93C",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Connect your POS"
                                }
                            ]
                        }),
                        isRetailerSubUser ? /*#__PURE__*/ _jsx(FoundationLock, {
                            strokeWidth: 1.5
                        }) : null
                    ]
                })
            })
        })
    });
};
var CTAButtonWrapper = styled(Column).withConfig({
    componentId: "sc-317954ed-0"
})([
    "width:fit-content;",
    "{width:100%;}"
], responsiveMediaQueries.mobile);
var CTAButton = styled(Button).withConfig({
    componentId: "sc-317954ed-1"
})([
    "width:fit-content;",
    "{width:100%;}"
], responsiveMediaQueries.mobile);
